import { render } from "./OnlyForDesktop.vue?vue&type=template&id=206fbe01&scoped=true"
import script from "./OnlyForDesktop.vue?vue&type=script&lang=js"
export * from "./OnlyForDesktop.vue?vue&type=script&lang=js"

import "./OnlyForDesktop.vue?vue&type=style&index=0&id=206fbe01&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206fbe01"]])

export default __exports__